// @ts-expect-error Untyped module
import { openSectionsLibraryModal } from 'ContentEditorUI/redux/actions/inpageActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { useContext } from 'react';
import { SECTIONS_LIBRARY_TOUR } from 'ContentEditorUI/constants/tours';
import { AFTER } from 'layout-dnd-utils/constants';
import { useDispatch } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RectangularButton from 'layout-dnd-components/DndToolbar/RectangularButton';
import I18n from 'I18n';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionsLibraryLayoutSectionEmptyState = ({
  layoutSectionId,
  gridLayoutId
}) => {
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minBlockSize: "300px",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.sectionsLibraryEmptyState.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.layoutSection.sectionsLibraryEmptyState.body"
      })
    }), /*#__PURE__*/_jsx(RectangularButton, {
      icon: AddIcon,
      top: 0,
      left: 0,
      useHighlightLine: false,
      responsiveSize: "medium",
      testId: "insert-new-section-button",
      label: I18n.text('inpage.actionToolbar.insertSection.label'),
      onClick: () => {
        dispatch(openSectionsLibraryModal({
          layoutSectionId,
          rowId: layoutSectionId,
          gridLayoutId,
          isEmptyLayoutSection: true,
          targetBeforeOrAfter: AFTER
        }));
        if (tour.getTour() === SECTIONS_LIBRARY_TOUR) {
          tour.finish();
        }
      }
    })]
  });
};
export default SectionsLibraryLayoutSectionEmptyState;